export default __webpack_public_path__ + "static/media/sticker_what.0246471d.svg";